(() => {
  if (!customElements.get('composition-faq')) {
    customElements.define('composition-faq', class extends HTMLElement {
      connectedCallback() {
        this.purchase = [...document.querySelectorAll('composition-catalog-product')]
          .find(element => element.dataset.section === this.dataset.section);
        if (!this.purchase) return;
        this.sync = () => {
          const active = this.purchase.querySelector('[data-composition-photo]:not([hidden])');
          if (!active) return;
          this.querySelectorAll('[data-faq-photo]').forEach(panel => {
            panel.hidden = panel.dataset.faqPhoto !== active.dataset.compositionPhoto;
          });
          const link = this.purchase.querySelector('[data-composition-edit]');
          if (link) this.querySelectorAll('[data-faq-personalize]').forEach(anchor => { anchor.href = link.href; });
        };
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.purchase, { subtree: true, attributes: true, attributeFilter: ['hidden', 'href'] });
        this.sync();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  const openRequestedGuide = () => {
    if (new URLSearchParams(location.search).get('size_guide') === '1' && typeof window.openSizeGuideDrawer === 'function') {
      window.openSizeGuideDrawer();
    }
  };
  // Deferred scripts run while readyState is interactive, before later module
  // scripts install the product drawer. Wait for those modules as well.
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', openRequestedGuide, { once: true });
  else openRequestedGuide();
})();
